const actions = {
  listarInventario: async (context, { vendor_id, per_page, page, numero }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/inventario`, {
      params: {
        data_inicial: "01/01/2001",
        vendor_id,
        per_page,
        page,
        numero,
      },
    });

    return response;
  },
  excluirInventario: async (context, { inventory_id, action }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(`/inventario/${inventory_id}/cancelar`, {
      inventory_id,
      action,
    });

    return response;
  },

  uploadInventario: async (context, { planilha, mapeamento, adicional }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.post(`/manutencao-planilha`, {
      planilha,
      mapeamento,
      adicional,
    });

    return response;
  },
  criarInventario: async (context, { vendor_id }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.post(`/inventario`, {
      vendor_id,
    });

    return response;
  },
  getInventario: async (context, { id }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/inventario/${id}`);

    return response;
  },
  getProdutos: async (context, { vendor_id, search }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/product-groups`, {
      params: {
        vendor_id,
        search,
      },
    });

    return response;
  },
  getProduto: async (context, { group_id, contract_id, search, per_page }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/contracts/${contract_id}/products`, {
      params: {
        group_id,
        per_page,
        search,
      },
    });

    return response;
  },
  adicionarProduto: async (context, { inventory_id, products }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(
      `/inventario/${inventory_id}/adicionar-produtos`,
      {
        action: "adicionar-produtos",
        inventory_id,
        products,
      }
    );

    return response;
  },
  removeProduto: async (context, { inventory_id, products }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(
      `/inventario/${inventory_id}/remover-produtos`,
      {
        action: "remover-produtos",
        inventory_id,
        products,
      }
    );

    return response;
  },
  contagem: async (context, { inventory_id }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(`/inventario/${inventory_id}/registrar`, {
      action: "registrar",
      inventory_id,
    });

    return response;
  },

  sincronizarInventarioCerradinho: async (context) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(`/integracao/estoque/sync`);

    return response;
  },

  sincronizarInventarioClealco: async (context) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(`/integracao/estoque/sync`);

    return response;
  },
  enviarContados: async (context, { inventory_id, products }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(
      `/inventario/${inventory_id}/adicionar-produtos-conferidos`,
      {
        action: "adicionar-produtos-conferidos",
        inventory_id,
        products,
      }
    );

    return response;
  },

  finalizar: async (context, { inventory_id }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(`/inventario/${inventory_id}/finalizar`, {
      action: "finalizar",
      inventory_id,
    });

    return response;
  },

  aprovar: async (context, { inventory_id, conferir_novamente }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(
      `/inventario/${inventory_id}/aprovar
`,
      {
        action: "aprovar",
        conferir_novamente,
        inventory_id,
      }
    );

    return response;
  },

  recontar: async (context, { inventory_id }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(
      `/inventario/${inventory_id}/recontar-divergente
`,
      {
        action: "recontar-divergente",
        inventory_id,
      }
    );

    return response;
  },

  aprovarDivergente: async (context, { inventory_id }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(
      `/inventario/${inventory_id}/aprovar-divergente
`,
      {
        action: "aprovar-divergente",
        inventory_id,
      }
    );

    return response;
  },
};

export const inventario = {
  namespaced: true,
  actions,
};
